import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BackArrow from "../../components/backArrow";
import ShopManagebuttons from "../../components/Shops_manage_buttons";
import { useSelector } from "react-redux";
import { extractIdFromSlug } from "../../utils/slugUtils";
import {
  useGetUserShopsByBusinessTypeQuery,
  useGetShopByIdQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../../features/shop/shopApiSlice";

const UsedItemsBussinesProfile = () => {
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId);
  const [shopData, setShopData] = useState();
  const [suggest, setSuggest] = useState(0);
  const [suggestdata, setSuggestdata] = useState();
  const [suggestdetail, setSuggestdetail] = useState(0);
  const { name } = useSelector((state) => state.user);

  const { data: userShopsRes } = useGetUserShopsByBusinessTypeQuery(
    {
      userid: name?._id,
      businessType: "usedShop",
    },
    { skip: !name?._id },
  );

  useEffect(() => {
    if (userShopsRes?.success && userShopsRes?.data?.Shops?.length > 0) {
      localStorage.setItem(
        "mycategory",
        userShopsRes.data.Shops[0]?.shopCategory?.name || "",
      );
    }
  }, [userShopsRes]);

  const {
    data: shopRes,
    isLoading: isShopLoading,
    error: shopError,
  } = useGetShopByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (shopRes?.success) {
      setShopData(shopRes?.data?.Shop);
    } else if (shopRes?.data?.Shop) {
      // In case success is not returned but data is
      setShopData(shopRes.data.Shop);
    } else if (shopRes?.Shop) {
      setShopData(shopRes.Shop);
    }
  }, [shopRes, shopError]);

  const [getSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  const suggestdatta = () => {
    if (shopData?._id) {
      getSuggestions(shopData._id)
        .unwrap()
        .then((res) => {
          setSuggestdata(res?.data[0]?.suggestions);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Container>
      <Col md={11} lg={11} className="mx-auto ">
        <Row>
          <Col md={4} lg={3} className="p-0">
            {" "}
            <OwnerShopProfile
              shopid={id}
              navigateTo="/used-items-update"
              Name="Update Used Items Profile"
              update="/used-items-update"
              // post="/useditems-postAdd"
              shopData={shopData}
              setSuggest={setSuggest}
              salespromotion="sales promotion"
              icon={<LocalOfferIcon className="silver-icon" />}
              suggestdatta={suggestdatta}
            />
          </Col>
          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="4">
                  <BackArrow
                    back={`/rawmaterial-useditem/` + id}
                    mystyle="d-none d-lg-block"
                  />
                </Col>
                <Col lg="8" className="mt-2 pe-4">
                  <ShopManagebuttons
                    businessurl="/used-items-shops"
                    shopid={id}
                  />
                </Col>
              </Row>
              <ShopItemsOwner
                urlPass="/used-item-owner-view"
                navigateto="/used-items-form"
                shopid={id}
                post={`/useditems-postAdd/${id}`}
                suggest={suggest}
                shopData={shopData}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                suggestdata={suggestdata}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default UsedItemsBussinesProfile;
